module.exports = __webpack_public_path__ + "static/media/tips2@2x.e6b419eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/tips2@2x.png
// module id = 1246
// module chunks = 0